module.exports = __webpack_public_path__ + "media/images/sp/plans/reason_01_after-724549b79b8d7cf9347902b193b48206.webp";